export default class DistanceFilterConverter {

    /** @type {number} */
    _maxValue

    constructor(maxValue) {
        this._maxValue = maxValue
        this.prepareForQuery = this.prepareForQuery.bind(this)
    }

    /**
     * Format distance filter values for backend.
     * @param {[number|null, number|null]|null} range Selected range filter value
     * @returns {[number|null, number|null]}
     */
    prepareForQuery(range) {
        const min = (range && range[0] > 0) ? range[0] : null
        const max = (range && range[1] < this._maxValue) ? range[1] : null
        return [min, max]
    }

}
